import { RECEIVE_SOURCES } from '../actions'

export default (
    state = {
        sections: [],
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case RECEIVE_SOURCES:
            return { ...state, ...data }

        default:
            return state
    }
}
